/*
 * Project: LegalPlace assistant
 * File: src\index.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */
import 'core-js/es6/map';
import 'core-js/es6/set';

// import 'react-polyfill'
import 'babel-polyfill';
import 'raf/polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import './styles/main.css';
import App from './App';

window.lp = {}
try{
    ReactDOM.render( 
            <App />,
        document.getElementById('root'));
}catch(e){
        console.log(e);
        console.log("error");
}
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js